import { render, staticRenderFns } from "./course_content.vue?vue&type=template&id=658a2b90&scoped=true&"
import script from "./course_content.vue?vue&type=script&lang=js&"
export * from "./course_content.vue?vue&type=script&lang=js&"
import style0 from "./course_content.vue?vue&type=style&index=0&id=658a2b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a2b90",
  null
  
)

export default component.exports